import React from "react";
import { HiOutlineInbox } from "react-icons/hi2";
import { PiPhoneLight } from "react-icons/pi";
import { FaLinkedin, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";

export default function Footer() {
  const handleMailTo = () => {
    const subject = encodeURIComponent("Inquiry about FlexNet Services");
    const body = encodeURIComponent(
      "Hello,\n\nI would like to learn more about your services.\n\nBest regards,"
    );
    window.location.href = `mailto:info@flexnet360.com?subject=${subject}&body=${body}`;
  };

  return (
    <div className="footer-parent">
      <div className="footer-grid">
        <div className="footer-container footer-left">
          <img src="/PNG-01.png" alt="logo" />
          <button className="news-button">
            <Link to="/">Subscribe FlexNet News</Link>
          </button>
        </div>

        <div className="footer-container">
          <ul>
            <li className="footer-title">FlexNet</li>
            <li className="footer-address normal-bold">
              Clemensstr. 30, <br /> D-80803 Munich, <br /> Germany
            </li>
          </ul>
        </div>

        <div className="footer-container">
          <ul>
            <li className="footer-title">Insight</li>
            <Link className="normal-bold" to="/blog-page">
              Blog
            </Link>
            <li></li>
          </ul>
        </div>

        <div className="footer-container">
          <ul>
            <li className="footer-title">Legals</li>
            <li>
              <Link
                target="_blank"
                to="https://opticoms.de/imprint/"
                className="normal-bold"
              >
                Imprint
              </Link>
            </li>
            <li>
              <Link
                target="_blank"
                to="https://opticoms.de/privacy-policy/"
                className="normal-bold"
              >
                Privacy Policy
              </Link>
            </li>
            <Link
              target="_blank"
              to="https://opticoms.de/cookies-policy/"
              className="normal-bold"
            >
              Cookie Policy
            </Link>
            <li></li>
          </ul>
        </div>

        <div className="footer-container">
          <ul>
            <li className="footer-title">Contact Us</li>

            <li>
              <button
                onClick={handleMailTo}
                className="email-button normal-bold"
              >
                <HiOutlineInbox className="icon" /> info@flexnet360.com
              </button>
            </li>

            <li>
              <Link
                to="https://www.linkedin.com/company/flexnet360"
                target="_blank"
                className="normal-bold contact-flex"
              >
                <FaLinkedin className="icon" /> Linkedin
              </Link>
            </li>

            <li>
              <Link
                className="normal-bold  contact-flex"
                to="https://www.youtube.com/channel/UCXd3t_7DbKKvjNh8HPFDGHA"
                target="_blank"
              >
                <FaYoutube className="icon youtube-icon" /> Youtube
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
